/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { useInView } from 'react-intersection-observer';
import { useGlobal } from 'reactn';
import { Remarkable } from 'remarkable'

import VidWrapperTwo from "../accessories/VidWrapper/VidWrapperTwo";
import ImgWrapper from "../accessories/ImgWrapper/ImgWrapper";
import "./Log.scss";

const Log = props => {
  const { 
    title,
    description,
    poster,
    video,
    videoMobile
  } = props;

  const [ showInfo ] = useGlobal("showInfo")

  const [ videoReady, setVideoReady ] = useState(false);
  const [ videoElement, getVideoElement ] = useState(null);

  const [ref, inView, entry] = useInView({
    threshold: 0.7
  })

  const md = new Remarkable('full');

  const handlePlayback = () => {
    if(video && videoElement) {
      if(inView || entry && entry.isIntersecting) {
        videoElement.current.play();
      } else {
        videoElement.current.pause();
      }
    }
  }

  useEffect(() => {
    handlePlayback();
  }, [inView, showInfo, videoElement, videoReady])

  return (
    <div className={classNames("log", showInfo && "show-info")}>
      <div className="text-wrapper">
        <div className="text">
          <h2 className="title">
            {title}
          </h2>
          <div className="description" dangerouslySetInnerHTML={{__html: md.render(description)}} />
        </div>
      </div>
      <div 
        className={classNames("media-wrapper", video && "video-log", videoReady && "video-ready")}
        ref={ref}
      >
        {/* <ImgWrapper src={poster} /> */}
        {
          video && (
            <VidWrapperTwo 
              src={video}
              poster={poster.childImageSharp.fluid.src}
              returnVideoEl={getVideoElement} 
            />
          )
        }
      </div>
    </div>
  )
}

export default Log
